import { render, staticRenderFns } from "./CadastroNascimentoLegado.vue?vue&type=template&id=0fd3d5aa&"
import script from "./CadastroNascimentoLegado.vue?vue&type=script&lang=js&"
export * from "./CadastroNascimentoLegado.vue?vue&type=script&lang=js&"
import style0 from "./CadastroNascimentoLegado.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports